<template>
  <transition name="slide-fade">
    <div class="history" v-if="hide">
      <div class="look-nav">
        <div class="handle-wrapper" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          <div>返回</div>
        </div>
        <div class="look-nav-center">历史记录</div>
        <div class="handle-wrapper" style="opacity: 0">
          <div class="icon-font">&#xe612;</div>
          <div>返回</div>
        </div>
      </div>
      <div class="history-select">
        <div class="input-wrapper">
          <input v-model="keyword" placeholder="请输入关键字"/>
        </div>
        <div style="margin:0 1vw">
          <DropDown content="请选择养护阶段" :items="maintainStageData" v-on:sendInfo = "showInfoMaintainStag"></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown content="请选择变更状态" :items="isReplaceData" v-on:sendInfo = "showInfoIsReplace"></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown content="请选择审核状态" :items="approveStatusData" v-on:sendInfo = "showInfoStatus"></DropDown>
        </div>
        <div class="query" @click="handleSearch(1)">查询</div>
      </div>
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="detail-item" style="width: 5%">序号</div>
            <div class="detail-item" style="width: 10%">批次号</div>
            <div class="detail-item" style="width: 20%">烟叶简称</div>
            <div class="detail-item" style="width: 10%">养护阶段</div>
            <div class="detail-item" style="width: 25%">位置</div>
            <div class="detail-item" style="width: 10%">计划养护时间</div>
            <div class="detail-item" style="width: 10%">审核状态</div>
            <div class="detail-item" style="width: 10%">变更状态</div>
          </div>
          <div class="detail-content">
            <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
              <div class="detail-item" style="width: 5%">{{index+1}}</div>
              <div class="detail-item" style="width: 10%">{{data.materialBatchNum}}</div>
              <div class="detail-item" style="width: 20%">{{data.materialName}}</div>
              <div class="detail-item" style="width: 10%">{{getMaintainStageData(data.maintainStage)}}</div>
              <div class="detail-item" style="width: 25%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.siteName">
                  <div class="popover" style="width: 8vw;text-align: center" slot="reference">{{data.siteName}}</div>
                </el-popover>
              </div>
              <div class="detail-item" style="width: 10%">{{data.maintainDays}}</div>
              <div class="detail-item" style="width: 10%" :class="data.approveStatus === 1 ? 'color-green' : data.approveStatus === 2 ? 'color-red' : 'color-set'">{{getApproveStatus(data.approveStatus)}}</div>
              <div class="detail-item" style="width: 10%">
                <div class="detail-btn" style="padding: 0.2vw 1vw;" :class="data.isChange ? 'item-apply' : 'item-audit-active' ">{{getIsChange(data.isChange)}}</div>
              </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > rows">
            <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import {queryMaintainPlanAndHistorys} from '../../../api/maintain'
export default {
  name: 'History',
  components: { DropDown },
  data () {
    return {
      hide: false,
      isReplaceData: [
        {name: '全部', value: ''},
        {name: '否', value: 0},
        {name: '是', value: 1}
      ],
      approveStatusData: [
        {name: '全部', value: ''},
        {name: '未审核', value: 0},
        {name: '已审核', value: 1},
        {name: '已拒绝', value: 2}
      ],
      maintainStageData: [
        {name: '全部', value: ''},
        {name: '自然醇化阶段', value: '01'},
        {name: '防霉杀虫阶段', value: '02'},
        {name: '气调醇化阶段', value: '03'},
        {name: '气调保质阶段', value: '04'}
      ],
      loading: true,
      keyword: '',
      approveStatus: '',
      maintainStage: '',
      isReplace: '',
      page: 1,
      rows: 5,
      total: '',
      tableData: []
    }
  },
  created () {
    let _this = this
    setInterval(function () {
      _this.hide = true
    }, 100)
    this.handleSearch(1)
  },
  methods: {
    getMaintainStageData: function (maintainStage) {
      if (maintainStage === '01') {
        return '自然醇化阶段'
      } else if (maintainStage === '02') {
        return '防霉杀虫阶段'
      } else if (maintainStage === '03') {
        return '气调醇化阶段'
      } else {
        return '气调保质阶段'
      }
    },
    getApproveStatus: function (approveStatus) {
      if (approveStatus === 0) {
        return '未审核'
      } else if (approveStatus === 1) {
        return '已审核'
      } else if (approveStatus === 2) {
        return '已拒绝'
      }
    },
    getIsChange: function (isChange) {
      if (isChange) {
        return '是'
      } else {
        return '否'
      }
    },
    handleSearch: function (type) {
      if (type === 1) {
        this.page = 1
      }
      let body = {
        page: this.page,
        rows: this.rows,
        keyword: this.keyword,
        approveStatus: this.approveStatus,
        maintainStage: this.maintainStage,
        isReplace: this.isReplace
      }
      this.loading = true
      queryMaintainPlanAndHistorys(body).then(res => {
        console.log(res)
        this.statistics = res.data.statistics
        res.data.rows && res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows || []
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    showInfoIsReplace: function (data) {
      this.isReplace = data.value
    },
    showInfoStatus: function (data) {
      this.approveStatus = data.value
    },
    showInfoMaintainStag: function (data) {
      this.maintainStage = data.value
    },
    backPath: function () {
      this.$router.go(-1)
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/History.vue